import {onFind,} from "@elements/init-modules-in-scope";
import { remote } from '@form-validation/validator-remote';
import * as formValidation from '@elements/form-validation';
import {findIn, findAllIn, on} from "@elements/dom-utils";

const selectors = {
    base: '.js-validate-guestcard-form',
    input: '.js-validate-guestcard-input',
    tenant: '.js-validate-guestcard__tenant',
};

export function init() {
    onFind(selectors.base, function (customValidatorForm) {
        let formInstance;
        formValidation.getApi(customValidatorForm).then((formApi) => {
            formInstance = formApi.getFormInstance();
            onFind(selectors.input, function (input) {
                if(!input) {
                    console.warn('No input found for guestcard validation');
                    return
                }
                let inputName = input.getAttribute('name');
                const tenantGroup = findIn(selectors.tenant, customValidatorForm);
                let checkedTenant = tenantGroup.querySelector('input[type="radio"]:checked') ? tenantGroup.querySelector('input[type="radio"]:checked').value : false;

                formInstance.addField(inputName, {
                    validators: {
                        remote: {
                            url: function () {
                                return input.getAttribute('data-guestcard-validation-url') || '';
                            },
                            data: function (validator, $field, value) {
                                const checkedTenant = tenantGroup.querySelector('input[type="radio"]:checked');
                                return checkedTenant ? { tenant: checkedTenant.value } : {};
                            },
                            blank: {},
                            method: 'POST',
                        },
                        notEmpty: {
                            enabled:  checkedTenant  !== '',
                        },
                    }
                });

                const tenantInputs = findAllIn('input', tenantGroup);
                tenantInputs.forEach(tenantInput => {
                    on('change', () => {
                        console.log(formInstance);
                        if (!tenantInput.value || tenantInput.value.trim() === '') {
                            console.warn('No input found for guestcard validation');
                            formInstance.disableValidator(inputName, 'remote');
                            formInstance.disableValidator(inputName, 'notEmpty');
                        }else{
                            console.warn('input found for guestcard validation');
                            formInstance.enableValidator(inputName, 'remote');
                            formInstance.enableValidator(inputName, 'notEmpty');
                        }
                        formInstance.revalidateField(inputName);
                    }, tenantInput);
                });
            });
        });
    });
}